// Libraries
import { FormControlLabel, Radio } from "@material-ui/core";
import classNames from "classnames";
import { useObserver } from "mobx-react-lite";
import React, { ReactElement } from "react";
import ReactHtmlParser from "react-html-parser";

// Core
import { isEmptyOrWhitespace } from "../../../../Core/Utils/Utils";

// Custom
import { BQSRadioButtonStyle } from "./../BQSPrimitivesStyle";
import { isNullOrUndefined } from "Custom/Utils/Utils";

interface IProps {
    className?: string;
    displayName: string;
    displayNamePlacement?: string;
    canExecute?: boolean;
    value: any;
}

export const BQSRadioButton: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const radioButtonClasses = BQSRadioButtonStyle();

    const getClassName = (): string => {
        return classNames({
            BQSRadioButton: true,
            [`${props.className}`]: !isEmptyOrWhitespace(props.className),
        });
    };

    const getDisplayName = (): ReactElement[] | string => {
        return !isEmptyOrWhitespace(props.displayName) ? ReactHtmlParser(props.displayName) : "";
    };

    const getDisplayNamePlacement = (): "bottom" | "top" | "end" | "start" => {
        return !isEmptyOrWhitespace(props.displayNamePlacement) ? (props.displayNamePlacement! as "bottom" | "top" | "end" | "start") : "end";
    };

    const getValue = (): string => {
        return !isNullOrUndefined(props.value) ? props.value.toString() : "";
    };

    const isDisabled = (): boolean => {
        return !isNullOrUndefined(props.canExecute) ? !props.canExecute : false;
    };

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <FormControlLabel
            classes={radioButtonClasses}
            className={getClassName()}
            control={<Radio />}
            disabled={isDisabled()}
            label={getDisplayName()}
            labelPlacement={getDisplayNamePlacement()}
            value={getValue()}
        />
    ));

    // #endregion Render Result
};
